// extracted by mini-css-extract-plugin
export var bullet = "_lx-q";
export var bulletText = "_lx-p";
export var bullets = "_lx-k";
export var callout = "_lx-g";
export var calloutBody = "_lx-i";
export var calloutLabel = "_lx-h";
export var checkIcon = "_lx-m";
export var checkList = "_lx-j";
export var checkSvg = "_lx-n";
export var checkText = "_lx-o";
export var fieldCard = "_lx-1";
export var fieldDescription = "_lx-5";
export var fieldHeader = "_lx-3";
export var fieldTitle = "_lx-4";
export var finalNote = "_lx-s";
export var flow = "_lx-x";
export var flowArrow = "_lx-v";
export var flowStep = "_lx-u";
export var helperText = "_lx-r";
export var inlineTitle = "_lx-t";
export var listItem = "_lx-l";
export var noteBody = "_lx-8";
export var noteBodyText = "_lx-9";
export var noteCard = "_lx-2";
export var noteIcon = "_lx-6";
export var noteTitle = "_lx-7";
export var productChoices = "_lx-w";
export var radioDot = "_lx-d";
export var radioDotSelected = "_lx-e";
export var radioDotSvg = "_lx-f";
export var selectableCard = "_lx-b";
export var selectableCardSelected = "_lx-c";
export var strongText = "_lx-a";
export var subHeading = "_lx-0";